{
  "DownloadReportDialog": {
    "title": "Download report",
    "fieldScope": "Workspace",
    "selectScope": "Select workspace",
    "wholeOrganization": "All workspaces — whole organisation",
    "download": "Download",
    "downloadFailed": "The report could not be downloaded. Please try again."
  },
  "entityTypes": {
    "contact": "Resources",
    "callout": "Callouts",
    "shortlist": "Shortlists",
    "callsheet": "Callsheets",
    "production": "Productions",
    "booking": "Bookings"
  },
  "ReportTemplateColumns": {
    "name": "Name",
    "description": "Description",
    "type": "Type"
  },
  "ReportTemplatesPage": {
    "title": "Report templates",
    "newTemplate": "New report template",
    "entityNameSingular": "report template",
    "rowActions": "Template actions",
    "editTemplate": "Edit template",
    "viewTemplate": "View template",
    "downloadReport": "Download report",
    "downloadReportInDialog": "Download report…",
    "archiveTemplate": "Archive template",
    "unarchiveTemplate": "Unarchive template",
    "archiveSuccess": "Report template archived",
    "unarchiveSuccess": "Report template restored",
    "emptyActive": "No report templates",
    "emptyArchived": "No archived report templates",
    "emptyMessage": "Data exports allow you to export data as a CSV file"
  },
  "WorkspaceReportingPage": {
    "title": "Reporting",
    "downloadReport": "Download report",
    "settingsLabel": "Configure report templates",
    "settingsInOrganization": "In this organization",
    "workspaceFailed": "This workspace couldn't be loaded, so its reports can't be downloaded."
  },
  "ReportTemplateEditor": {
    "titleCreate": "New report template",
    "titleEdit": "Edit report template",
    "titleView": "Report template",
    "create": "Create template",
    "save": "Save changes",
    "close": "Close",
    "name": "Name",
    "namePlaceholder": "e.g. Weekly talent roster",
    "nameRequired": "Enter a name",
    "description": "Description",
    "descriptionPlaceholder": "What the report is for",
    "reportOn": "Report on",
    "typeLabel": {
      "contact": "Resource type",
      "booking": "Booking type",
      "production": "Production type"
    },
    "typeAll": {
      "contact": "All resource types",
      "booking": "All booking types",
      "production": "All production types"
    },
    "archivedType": "{{name}} (archived)",
    "filters": "Filters",
    "filtersHint": "Which records the report includes. The workspace it is downloaded in is added on top.",
    "dateFields": {
      "created_at": "Created",
      "booking_date": "Booking date",
      "production_date": "Production date",
      "callsheet_date": "Callsheet date"
    },
    "dateGroup": "Dates",
    "booked": "Booked",
    "columns": "Columns",
    "columnsHint": "The file's columns, in this order.",
    "columnsRequired": "Pick at least one column",
    "idColumn": "ID",
    "guidColumn": "GUID",
    "relativeDates": {
      "TODAY": "Today",
      "YESTERDAY": "Yesterday",
      "TOMORROW": "Tomorrow",
      "LAST_7": "Last 7 days",
      "LAST_30": "Last 30 days",
      "NEXT_7": "Next 7 days",
      "NEXT_30": "Next 30 days",
      "LAST_WEEK": "Last week",
      "NEXT_WEEK": "Next week",
      "LAST_MONTH": "Last month",
      "NEXT_MONTH": "Next month",
      "QUARTER": "This quarter",
      "LAST_QUARTER": "Last quarter",
      "NEXT_QUARTER": "Next quarter"
    }
  },
  "ReportFile": {
    "ready": "Your report is ready.",
    "open": "Open report"
  }
}
